namespace TabAurous.ECommerce {
    export interface ECommRepairItemsRow {
        TransItemId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        Hallmark?: number;
        RefNo?: string;
        ItemTypeId?: number;
        ProductId?: number;
        AttributeId?: number;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CalcOnId?: number;
        UnitRate?: number;
        UnitLabour?: number;
        UnitCost?: number;
        NetAmount?: number;
        DiscountPer?: number;
        Discount?: number;
        GrossAmount?: number;
        EmployeeId?: number;
        RefTransItemId?: number;
        RefTransId?: number;
        ImageName?: string;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        AckStatus?: number;
        DeliveryDate?: string;
        CompanyId?: number;
        BagStatus?: string;
        WstPer?: number;
        WstWt?: number;
        Purity?: number;
        PureWeight?: number;
        MF?: number;
        MFAmount?: number;
        FancyCharges?: number;
        OtherCharges?: number;
        ProductCode?: string;
        ProductName?: string;
        TaxCode?: string;
        HSN?: string;
        HasBom?: boolean;
        CostMethodId?: Common.CostMethod;
        SalesCostMethodId?: Common.CostMethod;
        PurchaseCostMethodId?: Common.CostMethod;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        SuperTypeId?: number;
        CollectionId?: number;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Attribute?: string;
        CalcUnitId?: number;
        StockAllocation?: boolean;
        SieveId?: number;
        GroupSieveId?: number;
        Rate?: number;
        ServerDate?: string;
        IsDisabled?: boolean;
        IsRepairProcess?: boolean;
        KaratId?: number;
        KaratName?: string;
        ProductSizeId?: number;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        MetalId?: number;
        BOMDetails?: ECommRepairItemsBOMRow[];
        LaborDetails?: ECommRepairLaborRow[];
        TransDate?: string;
        VoucherNo?: string;
        DeptName?: string;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        Lab?: string;
        M1Pieces?: number;
        M1Weight?: number;
        M2Pieces?: number;
        M2Weight?: number;
        M3Pieces?: number;
        M3Weight?: number;
        M4Pieces?: number;
        M4Weight?: number;
        M5Pieces?: number;
        M5Weight?: number;
        M6Pieces?: number;
        M6Weight?: number;
        M7Pieces?: number;
        M7Weight?: number;
        M8Pieces?: number;
        M8Weight?: number;
        M9Pieces?: number;
        M9Weight?: number;
        M10Pieces?: number;
        M10Weight?: number;
        M11Pieces?: number;
        M11Weight?: number;
        M12Pieces?: number;
        M12Weight?: number;
        M1Amount?: number;
        M2Amount?: number;
        M3Amount?: number;
        M4Amount?: number;
        M5Amount?: number;
        M6Amount?: number;
        M7Amount?: number;
        M8Amount?: number;
        M9Amount?: number;
        M10Amount?: number;
        M11Amount?: number;
        M12Amount?: number;
        FromYear?: string;
        ToYear?: string;
        Week?: string;
        Day1Amount?: number;
        Day2Amount?: number;
        Day3Amount?: number;
        Day4Amount?: number;
        Day5Amount?: number;
        Day6Amount?: number;
        Day7Amount?: number;
        WeekAmount?: number;
        Month?: string;
        TimeSlot1?: number;
        Footfall1?: number;
        TimeSlot2?: number;
        Footfall2?: number;
        TimeSlot3?: number;
        Footfall3?: number;
        TimeSlot4?: number;
        Footfall4?: number;
        TimeSlot5?: number;
        Footfall5?: number;
        HUID?: string;
        StampId?: number;
    }

    export namespace ECommRepairItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'ProductName';
        export const localTextPrefix = 'ECommerce.ECommRepairItems';
        export const deletePermission = 'EComm:ECommRepair:Delete';
        export const insertPermission = 'EComm:ECommRepair:Add';
        export const readPermission = '*';
        export const updatePermission = 'EComm:ECommRepair:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            VoucherDate = "VoucherDate",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            PartyId = "PartyId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            Hallmark = "Hallmark",
            RefNo = "RefNo",
            ItemTypeId = "ItemTypeId",
            ProductId = "ProductId",
            AttributeId = "AttributeId",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            CalcOnId = "CalcOnId",
            UnitRate = "UnitRate",
            UnitLabour = "UnitLabour",
            UnitCost = "UnitCost",
            NetAmount = "NetAmount",
            DiscountPer = "DiscountPer",
            Discount = "Discount",
            GrossAmount = "GrossAmount",
            EmployeeId = "EmployeeId",
            RefTransItemId = "RefTransItemId",
            RefTransId = "RefTransId",
            ImageName = "ImageName",
            Remark = "Remark",
            SpecialRemark = "SpecialRemark",
            UserDescription = "UserDescription",
            AckStatus = "AckStatus",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            BagStatus = "BagStatus",
            WstPer = "WstPer",
            WstWt = "WstWt",
            Purity = "Purity",
            PureWeight = "PureWeight",
            MF = "MF",
            MFAmount = "MFAmount",
            FancyCharges = "FancyCharges",
            OtherCharges = "OtherCharges",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            TaxCode = "TaxCode",
            HSN = "HSN",
            HasBom = "HasBom",
            CostMethodId = "CostMethodId",
            SalesCostMethodId = "SalesCostMethodId",
            PurchaseCostMethodId = "PurchaseCostMethodId",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            SuperTypeId = "SuperTypeId",
            CollectionId = "CollectionId",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            Attribute = "Attribute",
            CalcUnitId = "CalcUnitId",
            StockAllocation = "StockAllocation",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            Rate = "Rate",
            ServerDate = "ServerDate",
            IsDisabled = "IsDisabled",
            IsRepairProcess = "IsRepairProcess",
            KaratId = "KaratId",
            KaratName = "KaratName",
            ProductSizeId = "ProductSizeId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            MetalId = "MetalId",
            BOMDetails = "BOMDetails",
            LaborDetails = "LaborDetails",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            DeptName = "DeptName",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            Lab = "Lab",
            M1Pieces = "M1Pieces",
            M1Weight = "M1Weight",
            M2Pieces = "M2Pieces",
            M2Weight = "M2Weight",
            M3Pieces = "M3Pieces",
            M3Weight = "M3Weight",
            M4Pieces = "M4Pieces",
            M4Weight = "M4Weight",
            M5Pieces = "M5Pieces",
            M5Weight = "M5Weight",
            M6Pieces = "M6Pieces",
            M6Weight = "M6Weight",
            M7Pieces = "M7Pieces",
            M7Weight = "M7Weight",
            M8Pieces = "M8Pieces",
            M8Weight = "M8Weight",
            M9Pieces = "M9Pieces",
            M9Weight = "M9Weight",
            M10Pieces = "M10Pieces",
            M10Weight = "M10Weight",
            M11Pieces = "M11Pieces",
            M11Weight = "M11Weight",
            M12Pieces = "M12Pieces",
            M12Weight = "M12Weight",
            M1Amount = "M1Amount",
            M2Amount = "M2Amount",
            M3Amount = "M3Amount",
            M4Amount = "M4Amount",
            M5Amount = "M5Amount",
            M6Amount = "M6Amount",
            M7Amount = "M7Amount",
            M8Amount = "M8Amount",
            M9Amount = "M9Amount",
            M10Amount = "M10Amount",
            M11Amount = "M11Amount",
            M12Amount = "M12Amount",
            FromYear = "FromYear",
            ToYear = "ToYear",
            Week = "Week",
            Day1Amount = "Day1Amount",
            Day2Amount = "Day2Amount",
            Day3Amount = "Day3Amount",
            Day4Amount = "Day4Amount",
            Day5Amount = "Day5Amount",
            Day6Amount = "Day6Amount",
            Day7Amount = "Day7Amount",
            WeekAmount = "WeekAmount",
            Month = "Month",
            TimeSlot1 = "TimeSlot1",
            Footfall1 = "Footfall1",
            TimeSlot2 = "TimeSlot2",
            Footfall2 = "Footfall2",
            TimeSlot3 = "TimeSlot3",
            Footfall3 = "Footfall3",
            TimeSlot4 = "TimeSlot4",
            Footfall4 = "Footfall4",
            TimeSlot5 = "TimeSlot5",
            Footfall5 = "Footfall5",
            HUID = "HUID",
            StampId = "StampId"
        }
    }
}
